import { useMemo } from "react";
import { useSettingContext } from "../context/SettingContext";

export const useSettingValue = (settingName) => {
  const settingsData = useSettingContext();

  return useMemo(() => {
    return settingsData?.find((d) => d.name === settingName)?.value || null;
  }, [settingsData, settingName]);
};
